import { enableBodyScroll, disableBodyScroll } from 'body-scroll-lock';

document.addEventListener('DOMContentLoaded', () => {
	const toggleButtons = document.querySelectorAll<HTMLElement>(
		'[data-toggle-navbar]',
	);

	toggleButtons.forEach((toggleButton) => {
		const elementSelector = toggleButton.getAttribute('data-toggle-navbar');
		if (!elementSelector) return;

		const element = document.querySelector<HTMLElement>(elementSelector);
		if (!element) return;

		const open = () => {
			toggleButton.setAttribute('aria-expanded', 'true');
			toggleButton.classList.add('hamburger--active');
			element.classList.add('header__navbar--active');
			disableBodyScroll(element);
		};

		const close = () => {
			toggleButton.setAttribute('aria-expanded', 'false');
			toggleButton.classList.remove('hamburger--active');
			element.classList.remove('header__navbar--active');
			enableBodyScroll(element);
		};

		toggleButton.addEventListener('click', () => {
			if (toggleButton.getAttribute('aria-expanded') === 'false') {
				open();
			} else {
				close();
			}
		});

		document.addEventListener('click', (event: MouseEvent) => {
			if (
				toggleButton.getAttribute('aria-expanded') == 'true' &&
				toggleButton !== event.target &&
				event.target instanceof HTMLElement &&
				!element.contains(event.target)
			) {
				close();
			}
		});
	});
});
